module.exports = __webpack_public_path__ + "static/img/ziyou01.c6e6fc8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ziyou01.png
// module id = /t42
// module chunks = 1